'use strict';
/*
* footer scroll btn
* @package krobot
* @deps jquery
*/
const $ = jQuery;

const ua = window.navigator.userAgent.toLowerCase();
const isiOS = ua.indexOf( 'iphone' ) > -1 || ua.indexOf( 'ipad' ) > -1 || ( ua.indexOf( 'macintosh' ) > -1 && 'ontouchend' in document );
let scrollPos;
let spHeaderHeight;

$( window ).on( 'load resize', function() {
	if ( window.matchMedia( '(min-width: 980px)' ).matches ) {
		spHeaderHeight = $( '.js-sp-header-pc' ).outerHeight();
	} else {
		spHeaderHeight = $( '.js-sp-header-sp' ).outerHeight();
	}
} );

$( '.js-scroll-link a[href^="#"]' ).on( 'click keypress', function() {
	const headerHeight = $( '.site-header' ).outerHeight();
	const scrollHref = $( this ).attr( 'href' );
	const scrollTarget = $( scrollHref === '#' || scrollHref === '' ? 'html' : scrollHref );
	if ( headerHeight ) {
		scrollPos = scrollTarget.offset().top - headerHeight;
	} else if ( spHeaderHeight ) {
		scrollPos = scrollTarget.offset().top - spHeaderHeight - 15;
	} else {
		scrollPos = scrollTarget.offset().top;
	}
	$( 'html, body' ).animate( { scrollTop: scrollPos }, 600, 'swing' );
	return false;
} );

$( '.sp-modal .js-modal-scroll-link a[href^="#"]' ).on( 'click keypress', function() {
	const headerHeight = $( '.site-header' ).outerHeight();
	const scrollHref = $( this ).attr( 'href' );
	if ( isiOS ) {
		$( 'body' ).css( 'position', '' );
		$( 'body' ).css( 'top', '' );
	}
	const scrollTarget = $( scrollHref === '#' || scrollHref === '' ? 'html' : scrollHref );
	if ( headerHeight ) {
		scrollPos = scrollTarget.offset().top - headerHeight;
	} else if ( spHeaderHeight ) {
		scrollPos = scrollTarget.offset().top - spHeaderHeight - 15;
	} else {
		scrollPos = scrollTarget.offset().top;
	}
	$( '.sp-modal' ).removeClass( 'expanded' );
	$( 'html, body' ).animate( { scrollTop: scrollPos }, 600, 'swing' );
	$( 'body' ).removeClass( 'off' );
	return false;
} );
